import { render, staticRenderFns } from "./captha.vue?vue&type=template&id=ccb1a7f0&scoped=true&"
import script from "./captha.vue?vue&type=script&lang=js&"
export * from "./captha.vue?vue&type=script&lang=js&"
import style0 from "./captha.vue?vue&type=style&index=0&id=ccb1a7f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb1a7f0",
  null
  
)

export default component.exports